module.exports = __webpack_public_path__ + "static/media/logo.f34953e1.svg";